<template>
  <!--功能：修改密码
   创建日期：2020-06-22
  开发人员：liufu-->
  <vxe-modal
    v-model="formVisible"
    title="修改密码"
    width="400px"
    height="290px"
  >
    <ResetPwd @closeParent="closeParent" />
  </vxe-modal>
</template>

<script>
import ResetPwd from '../common/resetPwd.vue'

export default {
  components: {
    ResetPwd
  },
  data() {
    return {
      formVisible: false
    }
  },
  methods: {
    // 关闭父窗口
    closeParent() {
      this.formVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.mian-box {
  width: 100%;
}
/deep/ .vxe-modal--header {
  line-height: 17px;
  display: flex;
  align-items: center;
}
/deep/ .el-tooltip {
  font-size: 17px;
}
.error-icon {
  position: absolute;
  right: 2px;
  margin-top: 6px;
  z-index: 10;
  color: #f56c6c;
  top: 0 !important;
}
.bts-box {
  display: flex;
  justify-content: flex-end;
  top: 90%;
}
</style>
